import axios from "axios";

export const createTwoFactorCodeRequest = async ({
  phoneNumberId,
}: {
  phoneNumberId: string;
}): Promise<void> => {
  await axios.post("/api/two_factor_codes", { phone_number_id: phoneNumberId });
};
